module.exports = {"id":"208045","name":"Oussama Tannane","rating":"74","photo":"./data/images/photos/4/208045.png","club":{"name":"ASSE","logo":"./data/images/clubs/ASSE.png"},"positions":["MD","MG","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OussamaTannane0.json
// module id = 3332
// module chunks = 0